class ComprobanteIngresoCfdisRelacionadosInputPipe {

  getName() {
    return 'cfdis-relacionados-ingreso';
  }

  apply(data, comprobante) {
    const cfdiUiid = data.Complemento?.TimbreFiscalDigital?.UUID;

    if (comprobante.isIngreso() && !!data.related && cfdiUiid) {
      data.CfdiRelacionados = {
        TipoRelacion: data.related,
        CfdiRelacionado: [
          {
            UUID: cfdiUiid
          }
        ]
      }
    }

    delete data.related;

    return data;
  }

}

export default ComprobanteIngresoCfdisRelacionadosInputPipe;